export const contacts = () =>
    `<div class="lightBlue"><p>If you want to connect, you can definitely add me on <a target="_blank" href="https://www.linkedin.com/in/paolomeola/">LinkedIn</a>.</p>` +
    `<p>Just make sure to <span class="lightRed">drop me a few lines about the reasons you want to connect</span>, otherwise there is a 100% chance that I will refuse your request.</p></div>`;
